module.exports = __webpack_public_path__ + "static/media/CommunityDetails2Screen_elIndeLivingStudioFeeUserPic_865980.fd46a6cc.jpg";